import React from 'react';
import SitSAMission from '../SitSAMission';

class About extends React.Component {
  render() {
    return(
      <div>
        <h1>
          About
        </h1>
        <div>
          Up To 15s has been coded using Swift for iOS. The Android version is currently being coded using React Native. It was coded by Stick in the Sand Apps (SitSA).
          <SitSAMission />
        </div>
      </div>
    );
  }
}

export default About;
